import React, { useState } from 'react';
import Tippy, { TippyProps } from '@tippyjs/react';
import { Instance } from 'tippy.js';
import classnames from 'classnames';
import usePermissions from 'store/authentication/usePermissions';
import Popup from 'components/AuditLog/Popup/Popup';
import UIIcon from 'components/UI/Icon/Icon';
import UIButton from 'components/UI/Button/Button';

const cbn = 'audit-log-icon';

type AuditLogIconProps = {
  childKey?: number;
  childType?: string;
  classes?: { wrapper?: string };
  classNames?: { wrapper?: string };
  entityId: string | number;
  entityType: string;
  position?: TippyProps['placement'];
};

function AuditLogIcon({
  childKey,
  childType,
  classes = {},
  classNames = {},
  entityId,
  entityType,
  position = 'left-start',
  ...restProps
}: AuditLogIconProps) {
  const [isOpen, setIsOpen] = useState(false);
  const permissions = usePermissions('log');
  if (!permissions?.list) {
    return null;
  }

  // This is the only way to give it a proper classname. Luckily this lifecycle
  // hook is called before the node is appended to the DOM. Reference:
  // https://atomiks.github.io/tippyjs/lifecycle-hooks/#onshow
  const onShow = (instance: Instance) => {
    if (instance.popper) {
      instance.popper.classList.add(`${cbn}__popper`);
    }
    setIsOpen(true);
  };

  const classesObj = {
    button: 'override',
    ...classes,
    ...classNames,
  };

  return (
    <Tippy
      className={classnames(cbn, classesObj.wrapper)}
      placement={position}
      arrow
      interactive
      trigger="click"
      theme="light"
      animation="shift-toward"
      maxWidth="none"
      onShow={onShow}
      content={
        // @ts-ignore
        <Popup
          childType={childType}
          childKey={childKey}
          entityType={entityType}
          entityId={entityId}
          isOpen={isOpen}
        />
      }
    >
      <UIButton className={classnames(classesObj.button)} {...restProps}>
        <UIIcon type="view_headline" />
        Logs
      </UIButton>
    </Tippy>
  );
}

export default AuditLogIcon;
